//declare var google: any;
declare var google: {
    maps: {
        OverlayView: {
            new();
        }
    }
};

export class SimpleDriverWindow extends google.maps.OverlayView {
    position: any;
    content: string;
    div: HTMLDivElement;
    constructor(map: any, position: any, content: string) {
        super();
        this.position = position;
        this.content = content;

        this.div = document.createElement('div');
        this.div.innerHTML = this.content;
        this.div.style.position = 'absolute';
        this.div.className = 'simple-info-window';
    }

    static getWindowContent(driver) {
        var contentString = `
        <div class="driver-name">
            <h4 class="driver-info-window-text"><div class="online-circle"></div> ${driver.name}</h4> 
        </div>
    `;
        return contentString;
    }

    onAdd() {
        const panes = this.getPanes();
        panes.floatPane.appendChild(this.div);
    }

    draw() {
        const overlayProjection = this.getProjection();
        const position = overlayProjection.fromLatLngToDivPixel(this.position);

        // Adjust the position of the info window relative to its anchor point
        const offsetX = -100; // Adjust this value to move the info window horizontally
        const offsetY = -95; // Adjust this value to move the info window vertically

        this.div.style.left = (position.x + offsetX) + 'px';
        this.div.style.top = (position.y + offsetY) + 'px';
    }

    // Implement the setPosition() method
    setPosition(position) {
        this.position = position;
        this.draw();
    };
    updateContent(content) {
        this.content = content;
        this.div.innerHTML = this.content;
        this.draw();
    }


    onRemove() {
        if (this.div && this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
            this.div = null!;
        }
    }
}